
const arrayMove = (_array, from, to) => {
    const array = _array.slice();
    const startIndex = to < 0 ? array.length + to : to;
    const item = array.splice(from, 1)[0];
    array.splice(startIndex, 0, item);
    return array;
};

module.exports = arrayMove;



// WEBPACK FOOTER //
// ./src/client/utils/array-move.js